export default __webpack_public_path__ + "static/media/gallery_00.15c383f9.jpg";